/**
 * 팀 ID에 해당하는 지역명을 반환
 * @param {string} teamId - 팀 ID
 * @returns {string} 팀 지역명 (없으면 빈 문자열)
 */
const matchTeamArea = (teamId) => {
    switch (teamId) {
        case 'K07': return '전남';
        case 'K35': return '김천';
        case 'K06': return '부산';
        case 'F10': return '부산';
        case 'K36': return '김포';
        case 'K20': return '경남';
        case 'K26': return '부천';
        case 'K27': return '안양';
        case 'K37': return '청주';
        case 'K08': return '성남';
        case 'K33': return '아산';
        case 'K34': return '충남아산';
        case 'K31': return '서울 E';
        case 'K09': return '서울';
        case 'K32': return '안산';
        case 'K38': return '천안';
        case 'K21': return '강원';
        case 'K16': return '전북';
        case 'K17': return '대구';
        case 'K23': return '상주';
        case 'K02': return '수원';
        case 'K01': return '울산';
        case 'K18': return '인천';
        case 'K05': return '전북';
        case 'K04': return '제주';
        case 'K03': return '포항';
        case 'K22': return '광주';
        case 'K10': return '대전';
        case 'K29': return '수원 FC';
        case 'K40': return '파주';
        case 'K41': return '김해';
        case 'K42': return '용인';
        case 'E01': return '춘천';
        case 'E02': return '충주';
        case 'K24_2012_상무': return '상무';
        case 'K08_2012_성남': return '성남';
        case 'K08_2012_천안': return '천안';
        case 'K08_1995_일화': return '일화';
        case 'K09_2012_치타스': return '안양';
        case 'K09_2012_안양': return '안양';
        case 'K09_2012_금성': return '금성';
        case 'K01_2012_현대': return '울산';
        case 'K04_2012_부천': return '부천';
        case 'K13_2012_한일': return '한일';
        case 'K11_2012_할렐': return '할렐루야';
        case 'K04_2012_유공': return '유공';
        case 'K12_2012_국민': return '국민';
        case 'K06_2012_대우': return '대우';
        case 'K03_1996': return '포항';
        case 'K03_2002': return '포항';
        case 'A97': return '시티';
        case 'A98': return '빠툼';
        case 'A99': return '멜버른';
        case 'F01': return '목포';
        case 'K39': return '화성';
        default: return '';
    }
}

/**
 * 2013년 이전 팀명에 따른 지역 반환
 * @param {string} teamName - 팀명
 * @returns {string|undefined} 지역명 (없으면 undefined)
 */
const oldMatchTeamArea = (teamName) => {
    if(teamName === '전남드래곤즈') {
        return '전남';
    } else if(teamName === '부산아이파크') {
        return '부산';
    } else if(teamName === '포항스틸러스') {
        return '포항';
    }
}

/**
 * 경기명(meetName)에 따른 리그 코드 반환 (2013년 이후 데이터)
 * @param {string} meetName - 경기명
 * @returns {string|undefined} 리그 코드 (kleague, facup, acl, rleague)
 */
const leagueName = (meetName) => {
    if (meetName.includes('K리그')) {
        return 'kleague';
    } else if(meetName.includes('FA컵') || meetName.includes('코리아컵')) {
        return 'facup';
    } else if(meetName.includes('ACL')) {
        return 'acl';
    } else if(meetName.includes('R리그')) {
        return 'rleague';
    }
}

/**
 * 2013년 이전 데이터 기준 리그 코드 반환
 * @param {number|string} meetSeq - 경기 시퀀스 번호
 * @param {string} meetName - 경기명
 * @returns {string|undefined} 리그 코드 (kleague, facup)
 */
const oldLeagueName = (meetSeq, meetName) => {
    meetSeq = Number(meetSeq);
    if(meetSeq === 1 || meetSeq === 2) {
        return 'kleague';
    } else if(meetSeq === 4) {
        if(meetName !== 'FA컵') {
            return 'kleague';
        } else {
            return 'facup';
        }
    }
}

/**
 * 리그 코드에 따른 표시용 리그명 반환
 * @param {string} leagueName - 리그 코드
 * @returns {string} 표시용 리그명 (없으면 빈 문자열)
 */
const leagueNameText = (leagueName) => {
    switch (leagueName) {
        case 'kleague': return 'K LEAGUE';
        case 'facup': return 'FA CUP';
        case 'acl': return 'ACL';
        case 'rleague': return 'R LEAGUE';
        default: return '';
    }
}

export {
    matchTeamArea,
    oldMatchTeamArea,
    leagueName,
    oldLeagueName,
    leagueNameText
}
